import LegalDoc from "@/components/LegalDoc";
import { PRIVACY_POLICY } from "@/legal/privacy-policy";

export default function PrivacyPolicy() {
  return (
    <LegalDoc
      doc={PRIVACY_POLICY}
      related={[
        { to: "/terms/planner", label: "Customer Terms of Service" },
        { to: "/terms/vendor", label: "Vendor Agreement" },
      ]}
    />
  );
}
